import React from "react";

import TvIcon from "@mui/icons-material/Tv";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import HeadphonesOutlinedIcon from "@mui/icons-material/HeadphonesOutlined";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import SubtitlesOutlinedIcon from "@mui/icons-material/SubtitlesOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import DataObjectIcon from "@mui/icons-material/DataObject";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import SecurityIcon from "@mui/icons-material/Security";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import LanguageIcon from "@mui/icons-material/Language";
import FlipIcon from "@mui/icons-material/Flip";
import ScheduleIcon from "@mui/icons-material/Schedule";
import AttachmentIcon from "@mui/icons-material/Attachment";
import { SvgIconProps } from "@mui/material";

interface ConfigFormIconProps extends SvgIconProps {
  icon?:
    | "video"
    | "audio"
    | "picture"
    | "import"
    | "subtitles"
    | "version"
    | "settings"
    | "meta"
    | "security"
    | "watermark"
    | "generated"
    | "delivery"
    | "scheduling"
    | "language"
    | "stitching"
    | "attachment"
    | undefined;
}

const ConfigFormIcon: React.FC<ConfigFormIconProps> = (props) => {
  const { icon, ...otherProps } = props;

  switch (icon) {
    case "video":
      return <TvIcon {...otherProps} />;
    case "audio":
      return <HeadphonesOutlinedIcon {...otherProps} />;
    case "picture":
      return <CameraAltOutlinedIcon {...otherProps} />;
    case "import":
      return <Inventory2OutlinedIcon {...otherProps} />;
    case "subtitles":
      return <SubtitlesOutlinedIcon {...otherProps} />;
    case "version":
      return <CompareArrowsIcon {...otherProps} />;
    case "settings":
      return <SettingsOutlinedIcon {...otherProps} />;
    case "meta":
      return <DataObjectIcon {...otherProps} />;
    case "watermark":
      return <ManageSearchIcon {...otherProps} />;
    case "security":
      return <SecurityIcon {...otherProps} />;
    case "delivery":
      return <AirportShuttleIcon {...otherProps} />;
    case "scheduling":
      return <ScheduleIcon {...otherProps} />;
    case "generated":
      return <SettingsBackupRestoreIcon {...otherProps} />;
    case "language":
      return <LanguageIcon {...otherProps} />;
    case "stitching":
      return <FlipIcon {...otherProps} />;
    case "attachment":
      return <AttachmentIcon {...otherProps} />;
    default:
      return <CategoryOutlinedIcon {...otherProps} />;
  }
};

export default ConfigFormIcon;
